import { create } from 'zustand';
import { BoundingBoxType, Coordinate } from '../types';
import { useShallow } from 'zustand/react/shallow';

// Store for managing image resource
type ImageStateType = {
    // The resource Image
    image: HTMLImageElement | null;

    // Partial or null bounding box coordinates for highlighting
    highlightedCoordinates: Coordinate[];

    actions: {
        //Sets the new image
        setImage: (image: HTMLImageElement | null) => void;

        // Set new highlight coordinates
        setCoordinates: (coordinates: Coordinate[]) => void;

        // Clear current highlight coordinates
        clearCoordinates: () => void;
    };
};

// Create Zustand store for image resource
const useImageStore = create<ImageStateType>()((set) => ({
    // Initial image
    image: null,

    // Initial coordinates
    highlightedCoordinates: [],

    actions: {
        // Reset coordinates to null
        clearCoordinates: () => set(() => ({ highlightedCoordinates: [] })),

        // Update coordinates with new partial bounding box
        setCoordinates: (coordinates) => set(() => ({ highlightedCoordinates: coordinates })),

        // Replaces the current image with the new image
        setImage: (image) => set(() => ({ image })),
    },
}));

export const useImageStoreActions = () => useImageStore(useShallow((state) => state.actions));

export const useImageStoreImage = () => useImageStore((state) => state.image);

export const useImageStoreHighlightedCoordinates = () =>
    useImageStore(useShallow((state) => state.highlightedCoordinates));

export default useImageStore;
